import { API_URL, ENDPOINTS, SCRIPT_PROD_URL } from './constants';
import { replaceDatesInJson } from './global';

export const ABORT_ERROR = 'REQUEST_ABORTED';
export const makeApiRequests = async ({ requestType, requestBody = {} }) => {
  try {
    const response = await (
      await fetch(SCRIPT_PROD_URL, {
        method: 'POST',
        body: JSON.stringify({
          accessToken: localStorage.getItem('user-token'),
          requestType,
          ...requestBody
        }),
        headers: {
          'Content-Type': 'text/plain;charset=utf-8'
        }
      })
    ).json();

    if (response['success']) {
      return { response };
    } else {
      return { error: response['reason'] || 'Oops something went wrong!' };
    }
  } catch (e) {
    console.log(e);
    return { error: 'Oops something went wrong!' };
  }
};

// REST API Request Handler
export const makeRESTApiRequest = async ({
  endpoint,
  contentType = 'application/json',
  requestBody,
  method = 'POST',
  stringify = true,
  signal,
  responseType = 'json'
}) => {
  const token = localStorage.getItem('user-token');
  const headers = {
    Authorization: token ? `Bearer ${token}` : undefined,
    Accept: 'application/*',
    'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone
  };

  if (endpoint !== ENDPOINTS.FILE) {
    headers['Content-Type'] = contentType;
  }

  if (contentType === 'multipart/form-data') {
    // Remove Content-Type header for multipart/form-data to let the browser set it
    delete headers['Content-Type'];
  }

  try {
    const response = await fetch(API_URL + endpoint, {
      method: method,
      body: requestBody
        ? stringify
          ? JSON.stringify(replaceDatesInJson(requestBody))
          : contentType === 'multipart/form-data'
          ? requestBody
          : replaceDatesInJson(requestBody)
        : undefined,
      headers,
      signal
    });

    let responseBody;
    if (responseType === 'blob') {
      responseBody = await response.blob();
    } else {
      responseBody = await response.json();
    }

    if (response.status < 200 || response.status >= 300) {
      if (response.status === 401) {
        setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 1500);
        return { error: 'Your session has expired, please try logging in again!' };
      }

      let errorMessage = 'Oops something went wrong!';
      let fieldErrors;
      if (responseType === 'json') {
        errorMessage = responseBody?.message || errorMessage;
        fieldErrors = responseBody?.fieldErrors;
      } else if (responseType === 'blob') {
        try {
          const text = await responseBody.text();
          const parsed = JSON.parse(text);
          errorMessage = parsed?.message || errorMessage;
          fieldErrors = parsed?.fieldErrors;
        } catch {
          // keep default errorMessage
        }
      }

      return { error: errorMessage, ...(fieldErrors != null ? { fieldErrors } : {}) };
    }

    return { response: responseBody };
  } catch (e) {
    if (e.name === 'AbortError') {
      return { error: ABORT_ERROR };
    }
    return { error: 'Oops something went wrong!' };
  }
};

export const deleteFileFromServer = file => {
  //we do not care for response
  makeRESTApiRequest({
    endpoint: ENDPOINTS.FILE_WITH_ID(file.filename),
    method: 'DELETE'
  });
};

export const readFile = async ({ fileName, mimeType }) => {
  const token = localStorage.getItem('user-token');
  try {
    const response = await fetch(API_URL + ENDPOINTS.FILE_STREAM_WITH_ID(fileName), {
      method: 'GET',
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined
      }
    });

    if (response.status < 200 || response.status >= 300) {
      if (response.status === 401) {
        setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 1500);
        return { error: 'Your session has expired, please try logging in again!' };
      }
      return { error: 'Could not load file!' };
    } else {
      const blobFromResponse = await response.blob();
      const blobWithFileMimeType = new Blob([blobFromResponse], { type: mimeType });
      const returnValue = URL.createObjectURL(blobWithFileMimeType);
      return { response: returnValue };
    }
  } catch (e) {
    console.log(e);
    return { error: 'Oops something went wrong!' };
  }
};
